module.exports = __webpack_public_path__ + "b24e87d5/img/pwrd-by-sourcery-black.bba9ba41.svg";